module.exports = __webpack_public_path__ + "03_short_brown.bc191a7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer5/03_short_brown.png
// module id = h6/U
// module chunks = 0